<vi-card [footer]="isIncoming || isCreated">
  <h2 title data-at-inv-header *ngIf="!isIncoming">
    {{ gatewaySerial }}
  </h2>
  <h2 title data-at-inv-header *ngIf="isIncoming && owner?.firstName">
    {{
      '+INVITATIONS.INVITATIONS.INCOMING_INVITATION.TITLE'
        | translate
          : { firstName: owner?.firstName, lastName: owner?.lastName, gatewaySerial: gatewaySerial }
    }}
  </h2>
  <div body *ngIf="isIncoming" class="flex flex-col gap-[24px]">
    <vi-item
      data-at-inv-date
      [title]="'+INVITATIONS.INVITATIONS.INVITATION.TIME_DATE' | translate: { timeDate: date }"
      [value]=""
    ></vi-item>
    <div class="flex flex-row lt-lg:flex-col gap-[24px] justify-between items-stretch">
      <vi-item
        class="flex-[100%] max-w-[50%] lt-lg:flex-auto"
        data-at-inv-address
        [title]="'+INVITATIONS.INVITATIONS.INVITATION.INSTALLATION_ADDRESS' | translate"
        [value]="address"
      ></vi-item>
      <vi-item
        class="flex-[100%] max-w-[50%] lt-lg:flex-auto"
        data-at-inv-phone
        [title]="'+INVITATIONS.INVITATIONS.INVITATION.TELEPHONE' | translate"
        value="{{ owner?.mobileNumber || owner?.phoneNumber | formatPhoneNumber }}"
      ></vi-item>
    </div>
    <vi-item
      data-at-inv-status
      [title]="'+INVITATIONS.INVITATION.STATUS' | translate"
      value="{{ status | translate }} {{
        expirationDate(invitation.tokenExpirationDate) | remaining
      }}"
    ></vi-item>
    <vi-item
      data-at-inv-note
      [title]="'+INVITATIONS.INVITATION.NOTE' | translate"
      [value]="invitation?.comment || '-'"
    ></vi-item>
  </div>

  <div body *ngIf="!isIncoming" class="flex flex-col gap-[24px]">
    <vi-item
      data-at-inv-date
      [title]="'+INVITATIONS.INVITATIONS.INVITATION.TIME_DATE' | translate: { timeDate: date }"
      [value]=""
    ></vi-item>
    <vi-item
      data-at-inv-status
      [title]="'+INVITATIONS.INVITATION.STATUS' | translate"
      value="{{ status | translate }} {{
        expirationDate(invitation.tokenExpirationDate) | remaining
      }}"
    ></vi-item>
    <vi-item
      data-at-inv-note
      [title]="'+INVITATIONS.INVITATION.NOTE' | translate"
      [value]="invitation?.comment || '-'"
    ></vi-item>
  </div>

  <div footer class="flex flex-row gap-[10px]" *ngIf="isCreated">
    <button
      data-at-inv-cancel
      mat-button
      color="primary"
      gtm="onOpen"
      gtmAction="Cancel invitation dialog"
      gtmCategory="invitation"
      [viConfirm]="{
        title: '+INVITATIONS.INVITATIONS.INVITATION.CANCEL_DIALOG.TITLE' | translate,
        content: '+INVITATIONS.INVITATIONS.INVITATION.CANCEL_DIALOG.MESSAGE' | translate,
        cancelBtn: 'GENERAL.BUTTON.DONT_CANCEL' | translate,
        confirmBtn: 'GENERAL.BUTTON.CANCEL' | translate
      }"
      (confirm)="onCancel()"
      (cancel)="onDismissCancelInvitationDialog()"
    >
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
  </div>

  <div footer class="flex flex-row gap-[10px]" *ngIf="isIncoming">
    <button
      data-at-inv-reject
      mat-button
      color="primary"
      gtm="onOpen"
      gtmAction="Reject invitation dialog"
      gtmCategory="invitation"
      [viConfirm]="{
        title: '+INVITATIONS.INVITATIONS.INVITATION.REJECT_DIALOG.TITLE' | translate,
        content: '+INVITATIONS.INVITATIONS.INVITATION.REJECT_DIALOG.MESSAGE' | translate,
        cancelBtn: 'GENERAL.BUTTON.DONT_REJECT' | translate,
        confirmBtn: 'GENERAL.BUTTON.REJECT' | translate
      }"
      (confirm)="onReject()"
      (cancel)="onDismissRejectInvitationDialog()"
    >
      {{ 'GENERAL.BUTTON.REJECT' | translate }}
    </button>
    <button
      data-at-inv-accept
      mat-button
      color="primary"
      gtm="onOpen"
      gtmAction="Confirm invitation dialog"
      gtmCategory="invitation"
      (click)="openConfirmationDialog()"
    >
      {{ 'GENERAL.BUTTON.ACCEPT' | translate }}
    </button>
  </div>
</vi-card>
